import { AnalyticsColumnSchema } from "@redotech/redo-analytics-custom-analytics/semantic-queries/v1/analytics-query/analytics-query-schema";
import * as z from "zod";
import {
  CustomAnalyticsReportColumnPresentationsSchema,
  CustomAnalyticsReportColumnSchema,
} from "./custom-analytics-report";

export const CUSTOM_ANALYTICS_REPORT_COLUMN_DEFINITION_LIMIT = 45;

export const CustomAnalyticsReportColumnDefinitionSchema = z.object({
  columns: z
    .array(AnalyticsColumnSchema)
    .min(1)
    .max(CUSTOM_ANALYTICS_REPORT_COLUMN_DEFINITION_LIMIT),
  columnPresentation: CustomAnalyticsReportColumnPresentationsSchema,
});
export interface CustomAnalyticsReportColumnDefinition extends z.infer<
  typeof CustomAnalyticsReportColumnDefinitionSchema
> {}

export const CustomAnalyticsReportColumnDraftSchema = z.object({
  definition: CustomAnalyticsReportColumnDefinitionSchema,
  expectedUpdatedAt: z.date(),
});
export interface CustomAnalyticsReportColumnDraft extends z.infer<
  typeof CustomAnalyticsReportColumnDraftSchema
> {}

export const CustomAnalyticsReportColumnEditorSchema = z.object({
  definition: CustomAnalyticsReportColumnDefinitionSchema,
  columnsMetadata: z.array(CustomAnalyticsReportColumnSchema),
});
export interface CustomAnalyticsReportColumnEditor extends z.infer<
  typeof CustomAnalyticsReportColumnEditorSchema
> {}

export const CustomAnalyticsReportCatalogEntrySchema = z.object({
  id: z.string(),
  label: z.string(),
  category: z.string(),
  sourceLabel: z.string(),
  selectedSourceNames: z.array(z.string()).default([]),
  description: z.string(),
  kind: z.enum(["metric", "detail"]),
  effect: z.string(),
  searchTerms: z.array(z.string()),
  availability: z.enum(["available", "selected", "unavailable"]),
  reason: z.string().optional(),
  reasonCode: z
    .enum(["column_limit", "incompatible", "unsupported"])
    .optional(),
  capabilities: z.object({
    filterSource: z.enum(["source", "projection_source_only", "unsupported"]),
    filterResult: z.boolean(),
    sort: z.boolean(),
    group: z.boolean(),
  }),
});
export interface CustomAnalyticsReportCatalogEntry extends z.infer<
  typeof CustomAnalyticsReportCatalogEntrySchema
> {}

export class InvalidCustomAnalyticsReportColumnDraftError extends Error {}

export class UnavailableCustomAnalyticsReportColumnError extends InvalidCustomAnalyticsReportColumnDraftError {}
